import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { async } from '@angular/core/testing';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  messages: string = "";
  isSubmit: boolean = false;
  userProfile: any = {};
  constructor(
    private apiService: ApiService,
    private router: Router
  ) { }

  async ngOnInit() {
    try {
      this.userProfile = await this.apiService.initLineLiffSDK();
      console.log(`Hi ${this.userProfile?.displayName}!`);
    } catch (err) {
      console.log(`${err}!`);
    }
  }

  async onSubmit() {
    try {
      this.isSubmit = false;
      if (this.messages) {
        this.isSubmit = true;
        var response: any = await this.accessLineUser();
        if (response.success) {
          Swal.fire({
            icon: "success",
            title: response.sendMessage
          }).then(async (res: any) => {
             this.router.navigate(["otp"], { queryParams: {employeeId: this.messages}});
          });
        } else {
          Swal.fire({
            icon: "error",
            title: response.sendMessage
          });
          this.messages = "";
        }
      }
    } catch (e) {
      //alert(e)
      Swal.fire({
        icon: "error",
        title: JSON.stringify(e)
      });
    }
  }

  onCheckEnter(event: any) {
    if (event.keyCode === 13) {
      this.onSubmit();
    }
  }

  async accessLineUser() {
    return await new Promise(async (resolve, reject) => {
      try {
        const request_body = {
          LineId: this.userProfile?.userId ? this.userProfile?.userId : "",
          EmployeeUser: this.messages ? this.messages : "",
          ResetOTP: 0
        };
        await this.apiService.accessLineUser(request_body)
          .toPromise()
          .then(async (response: any) => {
            resolve(response);
          }).catch(async (err: any) => reject(err));
      } catch (err) {
        reject(err);
      }
    });
  }
}
